export default "__VITE_ASSET__87f75806__"